import { CommonModule } from '@angular/common';
import { Component, forwardRef, input, Input, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import {
  BeforeUploadHandler,
  FileItem,
  FileUploaderAdapter,
} from './file-uploader.adapter';
import { Icon } from '../icon/icon.component';
import { Label } from '../label/label.component';
import { Hint } from '../hint/hint.component';
import { Spinner } from '../spinner/spinner.component';

@Component({
  selector: 'app-file-uploader',
  standalone: true,
  imports: [
    CommonModule,
    DragDropModule,
    Icon,
    Label,
    Hint,
    FormsModule,
    Spinner,
  ],
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploader),
      multi: true,
    },
  ],
})
export class FileUploader extends FileUploaderAdapter {
  isBoothApplication = input<boolean>(false);
  @Input() beforeUpload?: BeforeUploadHandler;
  isDragOvered = signal(false);

  protected override getBeforeUploadHandler(): BeforeUploadHandler | undefined {
    return this.beforeUpload;
  }

  onDragOver(e: DragEvent) {
    this.isDragOvered.set(true);
    e.preventDefault();
  }

  onDragLeave(e: DragEvent) {
    this.isDragOvered.set(false);
    e.preventDefault();
  }

  onDragDrop(e: DragEvent) {
    this.isDragOvered.set(false);
    this.onFileDrop(e);
  }

  openImage(url: string) {
    window.open(url);
  }

  onDrop(ev: CdkDragDrop<FileItem[]>) {
    if (ev.container === ev.previousContainer) {
      this.items.update(items => {
        const temp = items;
        moveItemInArray(temp, ev.previousIndex, ev.currentIndex);
        return temp;
      });

      this.writeValue(this.items().map(item => item.url));
      this.onChange(this.value());
    }
  }
}
